/** @format */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "fusion-plugin-react-router";
import Navbar from "../shared/components/navbar";
import Footer from "../shared/components/footer";
import TqStart from "../features/quote/steps/tqStart";
import QuoteStep from "../features/quote/enums/QuoteStep";
import { fetchNewQuote } from "../features/quote/services/quoteService";
import UberDetailsConfirmationModal from "../features/quote/components/uberDetailsConfirmationModal";
import useAppStateStore from "../shared/store/AppStateStore";
import AllQuoteSteps from "../features/quote/allQuoteSteps";
import AllBuySteps from "../features/buy/allBuySteps";
import useQuoteStore from "../features/quote/store/QuoteStore";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import { scrollToTop } from "../shared/utils/scrollUtils";
import { fetchAddonsDescriptions } from "../features/buy/services/buyService";
import Loader from "../shared/components/Loader";

const TaxiJourney = () => {
  const STATE = useAppStateStore();
  const quote = useQuoteStore().quote;
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");
  const navigate = useNavigate();
  const [isConfirmationModal, setIsConfirmationModal] = useState(true);
  const [newQuoteLoading, setNewQuoteLoading] = useState(false);

  const setNextStep = (stepName) => {
    STATE.setCurrentStep(stepName);
  };

  useEffect(() => {
    if (STATE.currentStep === QuoteStep.TQ1 && !STATE.quoteCall) {
      if (!quote?.quote?.risk?.drivers?.[0]?.address?.postcode) {
        const fetchData = async () => {
          try {
            setNewQuoteLoading(true);
            await fetchNewQuote(code, navigate);
          } catch (error) {
            console.error("Error fetching quote:", error);
          } finally {
            setNewQuoteLoading(false);
          }
          fetchAddonsDescriptions();
        };
        fetchData();
      }
    }
  }, [STATE.currentStep]);

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_START_LANDING);
  }, []);

  return (
    <>
      <div>
        <Navbar />
        {STATE.currentStep === QuoteStep.TQSTART ? (
          <TqStart setNextStep={setNextStep} />
        ) : (
          <div className="mainBody">
            <AllBuySteps />
            <AllQuoteSteps />
          </div>
        )}
        <Footer />
      </div>

      {newQuoteLoading && <Loader text="Fetching your Uber details..." />}

      {isConfirmationModal &&
        STATE.currentStep === QuoteStep.TQ1 &&
        !newQuoteLoading && (
          <UberDetailsConfirmationModal
            onClose={() => {
              setIsConfirmationModal(false);
              scrollToTop();
            }}
          />
        )}
    </>
  );
};

export default TaxiJourney;
